import { computed, defineComponent, useContext, useCssModule } from '@nuxtjs/composition-api';
import { IMAGE_WIDTH } from './';
export default defineComponent({
    name: 'ArticleHeaderImage',
    props: {
        article: {
            default: () => ({}),
            type: Object,
        },
        articleIndex: {
            default: 0,
            type: Number,
        },
        schemaDisabled: {
            default: false,
            type: Boolean,
        },
    },
    setup(props) {
        /**
         * Composables.
         */
        const context = useContext();
        const css = useCssModule();
        /**
         * Context.
         */
        const viewport = context.$viewport;
        const { alt, metadata, title } = (props.article || {}).photo || {};
        const { height: originalHeight = 1, width: originalWidth = 1 } = metadata || {};
        const aspectRatio = originalHeight / originalWidth;
        const caption = alt || title;
        const size = computed(() => {
            if (props.articleIndex > 0) {
                return {};
            }
            let width = IMAGE_WIDTH[viewport.breakpoint] || 0;
            let height = Math.round(width * aspectRatio);
            height = Math.min(originalHeight, height);
            width = Math.min(originalWidth, width);
            return {
                height,
                width,
            };
        });
        const preload = computed(() => {
            if (props.articleIndex > 0) {
                return {};
            }
            const hid = 'ArticleHeaderImage';
            const { height, width } = size.value;
            if (!height || !width) {
                return {};
            }
            return {
                height,
                hid,
                width,
            };
        });
        return {
            css,
            caption,
            preload,
            size,
        };
    },
});
